import { Fonts } from "../../config";

const FontStyle = {
  medium12: {
    fontSize: Fonts.sizes.smaller,
    fontFamily: Fonts.medium,
  },
  medium14: {
    fontSize: Fonts.sizes.small,
    fontFamily: Fonts.medium,
  },
  medium16: {
    fontSize: Fonts.sizes.regular,
    fontFamily: Fonts.medium,
  },
  medium42: {
    fontSize: Fonts.sizes.extraLarge,
    fontFamily: Fonts.medium,
  },
  roman12: {
    fontSize: Fonts.sizes.smaller,
    fontFamily: Fonts.roman,
  },
  roman14: {
    fontSize: Fonts.sizes.small,
    fontFamily: Fonts.roman,
  },
  roman16: {
    fontSize: Fonts.sizes.regular,
    fontFamily: Fonts.roman,
  },
  bold10: {
    fontSize: Fonts.sizes.extraSmall,
    fontFamily: Fonts.bold,
  },
  bold12: {
    fontSize: Fonts.sizes.smaller,
    fontFamily: Fonts.bold,
  },
  bold14: {
    fontSize: Fonts.sizes.small,
    fontFamily: Fonts.bold,
  },
  bold16: {
    fontSize: Fonts.sizes.regular,
    fontFamily: Fonts.bold,
  },
  bold18: {
    fontSize: Fonts.sizes.medium,
    fontFamily: Fonts.bold,
  },
  bold22: {
    fontSize: Fonts.sizes.large,
    fontFamily: Fonts.bold,
  },
  semibold12: {
    fontSize: Fonts.sizes.smaller,
    fontFamily: Fonts.semibold,
  },
  semibold14: {
    fontSize: Fonts.sizes.small,
    fontFamily: Fonts.semibold,
  },
  semibold16: {
    fontSize: Fonts.sizes.regular,
    fontFamily: Fonts.semibold,
  },
  light14: {
    fontSize: Fonts.sizes.small,
    fontFamily: Fonts.light,
  },
  italic14: {
    fontSize: Fonts.sizes.small,
    fontFamily: Fonts.italic,
  },
};

export default FontStyle;
